<template>
  <div class="zv-page">
    <div class="zv-content">
      <div class="zv-block">
        <div class="zv-breadcrumb-wrap">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/data-input/articleList' }"
              >文字管理</el-breadcrumb-item
            >
            <el-breadcrumb-item>{{ this.isEdit ?'修改文章' : '新增文章' }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <!-- <div class="zv-page-title">新增事件</div> -->
        <el-form
          ref="myForm"
          :model="formData"
          :rules="formRules"
          label-width="100px"
        >
          <el-form-item label="文件类型:" prop="type">
            <el-radio-group v-model="formData.type">
              <el-radio :label="1">资讯</el-radio>
              <el-radio :label="2">视频</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label="所属分类:" prop="article_category_id">
            <!-- <el-select
                class="el-input-width1"
                v-model="formData.article_category_id"
                @change="changeCategory"
                filterable
              >
                <el-option
                  v-for="item in categoryList"
                  :key="item.id"
                  :label="item.level + '-' +item.category_name"
                  :value="item.id"
                >
                </el-option>
              </el-select> -->
              <el-cascader
                v-model="formData.article_category_id"
                @change="changeCategory"
                :options="categoryList"
                :props="{ checkStrictly: true, children:'child',label: 'category_name',value: 'id'  }"
                clearable>
              </el-cascader>
          </el-form-item>

          <!-- <el-form-item label="事件类型:" >
            <el-select
                class="el-input-width1"
                v-model="formData.category_type"
                filterable
              >
                <el-option
                  v-for="item in categoryTypeList"
                  :key="item.id"
                  :label="item.category_name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
          </el-form-item> -->

          <el-form-item label="标题:" prop="title">
            <el-input
              class="el-input-width500"
              v-model="formData.title"
            ></el-input>
          </el-form-item>

          <div v-for="(item,index) in itemData" :key="index">
            <el-form-item :label="item.field_name+':'" v-if="item.field_type == '时间选择器' && item.enable">
              <!-- 时间选择 -->
              <el-date-picker
                class="el-input-width1"
                v-model="formData[item.form_field_name]"
                type="datetime"
                :placeholder="item.inputhit"
                value-format="timestamp"
              >
              </el-date-picker>
              <span v-if="item.inputhit" style="margin-left: 10px;color: gray; font-size: 12px">*{{item.inputhit}}</span>
            </el-form-item>

            <el-form-item :label="item.field_name+':'" v-if="item.field_type == '枚举单选' && item.enable">
              <!-- 枚举单选 -->
              <el-radio-group v-model="formData[item.form_field_name]">
                <el-radio v-for="(items,index) in item.field_config_data.options" :key="index+30" :label="items.text">{{items.text}}</el-radio>
              </el-radio-group>
              <span v-if="item.inputhit" style="margin-left: 10px;color: gray; font-size: 12px">*{{item.inputhit}}</span>
            </el-form-item>

            <el-form-item :label="item.field_name+':'" v-if="item.field_type == '枚举多选' && item.enable">
              <!-- 枚举多选 -->
              <el-checkbox-group v-model="formData[item.form_field_name]">
                <el-checkbox v-for="(items,index) in item.field_config_data.options" :key="index+30" :label="items.text">{{items.text}}</el-checkbox>
              </el-checkbox-group>
              <span v-if="item.inputhit" style="margin-left: 10px;color: gray; font-size: 12px">*{{item.inputhit}}</span>
            </el-form-item>

            <el-form-item :label="item.field_name+':'" v-if="item.field_type == '下拉多选' && item.enable">
              <!-- 下拉多选 -->
              <el-select
                  class="el-input-width1"
                  v-model="formData[item.form_field_name]"
                  multiple
                  filterable
                >
                  <el-option
                    v-if="item.field_config_data.options_lib == '事件类型库'"
                    v-for="(itemLi,index) in item.eventList"
                    :key="index+100"
                    :label="itemLi.category_name"
                    :value="itemLi.category_name"
                  >
                  </el-option>
                  <el-option
                    v-if="item.field_config_data.options_lib == '风险等级库'"
                    v-for="(itemLi,index) in riskData"
                    :key="index+100"
                    :label="itemLi.label"
                    :value="itemLi.label"
                  >
                  </el-option>
                   <el-option
                    v-if="item.field_config_data.options_lib == '影响等级库'"
                    v-for="(itemLi,index) in effectData"
                    :key="index+100"
                    :label="itemLi.label"
                    :value="itemLi.label"
                  >
                  </el-option>
                  <el-option
                    v-if="item.field_config_data.options_lib == '地区库'"
                    v-for="(itemLi,index) in areaData"
                    :key="index+100"
                    :label="itemLi.full_area_name"
                    :value="itemLi.full_area_name"
                  >
                  </el-option>
                </el-select>
                <span v-if="item.inputhit" style="margin-left: 10px;color: gray; font-size: 12px">*{{item.inputhit}}</span>
            </el-form-item>

            <el-form-item :label="item.field_name+':'" v-if="item.field_type == '下拉单选' && item.enable">
              <!-- 下拉单选 -->
              <el-select
                  class="el-input-width1"
                  v-model="formData[item.form_field_name]"
                  filterable
                >
                  <el-option
                    v-if="item.field_config_data.options_lib == '事件类型库'"
                    v-for="(itemLi,index) in item.eventList"
                    :key="index+100"
                    :label="itemLi.category_name"
                    :value="itemLi.category_name"
                  >
                  </el-option>
                  <el-option
                    v-if="item.field_config_data.options_lib == '风险等级库'"
                    v-for="(itemLi,index) in riskData"
                    :key="index+100"
                    :label="itemLi.label"
                    :value="itemLi.label"
                  >
                  </el-option>
                  <el-option
                    v-if="item.field_config_data.options_lib == '影响等级库'"
                    v-for="(itemLi,index) in effectData"
                    :key="index+100"
                    :label="itemLi.label"
                    :value="itemLi.label"
                  >
                  </el-option>
                   <el-option
                    v-if="item.field_config_data.options_lib == '地区库'"
                    v-for="(itemLi,index) in areaData"
                    :key="index+100"
                    :label="itemLi.full_area_name"
                    :value="itemLi.full_area_name"
                  >
                  </el-option>
                </el-select>
                <span v-if="item.inputhit" style="margin-left: 10px;color: gray; font-size: 12px">*{{item.inputhit}}</span>
            </el-form-item>

            <el-form-item :label="item.field_name+':'" v-if="item.field_type == '联动多选' && item.enable">
              <el-cascader
                v-model="formData[item.form_field_name]"
                :options="item.LinkList"
                :props="{ multiple: true, checkStrictly: true, children:'child',label: 'category_name',value: 'id'  }"
                clearable>
              </el-cascader>
              <span v-if="item.inputhit" style="margin-left: 10px;color: gray; font-size: 12px">*{{item.inputhit}}</span>
            </el-form-item>

            <el-form-item :label="item.field_name+':'" v-if="item.field_type == '简单文本输入' && item.enable">
              <!-- 简单文本输入 -->
              <el-input class="el-input-width500" type="textarea" rows="3" v-model="formData[item.form_field_name]" :maxlength="item.field_length != 0 ?item.field_length:''" show-word-limit filterable></el-input>
              <span v-if="item.inputhit" style="margin-left: 10px;color: gray; font-size: 12px">*{{item.inputhit}}</span>
            </el-form-item>

            <el-form-item :label="item.field_name+':'" v-if="item.field_type == '富文本输入' && item.enable">
              <!-- 富文本输入 -->
              <quill-editor v-model="formData[item.form_field_name]"
                ref="myQuillEditor"
                class="editer"
                :options="editorOption">
              </quill-editor>
            </el-form-item>

            <el-form-item :label="item.field_name+':'" v-if="item.field_type == '图片上传' && item.enable">
              <el-upload
                :action="imageUrl"
                accept="image/*"
                :show-file-list="true"
                :data="imageData"
                name="file"
                list-type="picture-card"
                :limit="item.field_length != 0 ?item.field_length:true"
                :file-list="formData[item.form_field_name] || fileList"
                :on-success="(value)=> handleSuccess(item.form_field_name, value)"
                :on-preview="handlePictureCardPreview"
                :on-remove="(value)=> handleRemove(item.form_field_name, value)">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-dialog :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt="">
              </el-dialog>
            </el-form-item>

            <el-form-item :label="item.field_name+':'" v-if="item.field_type == '人数统计' && item.enable">
              <div class="zv-flex-wrap zv-flex-1 style-col-5">
                <div class="zv-form-item-col">
                  <el-input
                    v-model="formData[item.form_field_name].death"
                    type="input"
                  >
                    <template slot="prepend">死亡</template>
                    <template slot="append">人</template>
                  </el-input>
                </div>
                <div class="zv-form-item-col">
                  <el-input
                    v-model="formData[item.form_field_name].injured"
                    type="input"
                  >
                    <template slot="prepend">受伤</template>
                    <template slot="append">人</template>
                  </el-input>
                </div>
                <div class="zv-form-item-col">
                  <el-input
                    v-model="formData[item.form_field_name].death_and_injured"
                    type="input"
                  >
                    <template slot="prepend">伤亡</template>
                    <template slot="append">人</template>
                  </el-input>
                </div>
                <div class="zv-form-item-col">
                  <el-input
                    v-model="formData[item.form_field_name].missing"
                    type="input"
                  >
                    <template slot="prepend">失踪</template>
                    <template slot="append">人</template>
                  </el-input>
                </div>
                <div class="zv-form-item-col">
                  <el-input
                    v-model="formData[item.form_field_name].kidnap"
                    type="input"
                  >
                    <template slot="prepend">被绑架/劫持</template>
                    <template slot="append">人</template>
                  </el-input>
                </div>
                <div class="zv-form-item-col">
                  <el-input
                    v-model="formData[item.form_field_name].arrest"
                    type="input"
                  >
                    <template slot="prepend">被捕</template>
                    <template slot="append">人</template>
                  </el-input>
                </div>
                <div class="zv-form-item-col">
                  <el-input
                    v-model="formData[item.form_field_name].captured"
                    type="input"
                  >
                    <template slot="prepend">被俘</template>
                    <template slot="append">人</template>
                  </el-input>
                </div>
                <div class="zv-form-item-col">
                  <el-input
                    v-model="formData[item.form_field_name].strike"
                    type="input"
                  >
                    <template slot="prepend">罢工</template>
                    <template slot="append">人</template>
                  </el-input>
                </div>
                <div class="zv-form-item-col">
                  <el-input
                    v-model="formData[item.form_field_name].march"
                    type="input"
                  >
                    <template slot="prepend">游行</template>
                    <template slot="append">人</template>
                  </el-input>
                </div>
                <div class="zv-form-item-col">
                  <el-input
                    v-model="formData[item.form_field_name].rape"
                    type="input"
                  >
                    <template slot="prepend">被强奸</template>
                    <template slot="append">人</template>
                  </el-input>
                </div>
                <div class="zv-form-item-col">
                  <el-input
                    v-model="formData[item.form_field_name].disaster"
                    type="input"
                  >
                    <template slot="prepend">受灾</template>
                    <template slot="append">人</template>
                  </el-input>
                </div>
                <div class="zv-form-item-col">
                  <el-input
                    v-model="formData[item.form_field_name].infection"
                    type="input"
                  >
                    <template slot="prepend">感染</template>
                    <template slot="append">人</template>
                  </el-input>
                </div>
                <div class="zv-form-item-col">
                  <el-input
                    v-model="formData[item.form_field_name].involved"
                    type="input"
                  >
                    <template slot="prepend">涉案</template>
                    <template slot="append">人</template>
                  </el-input>
                </div>
                <div class="zv-form-item-col">
                  <el-input
                    v-model="formData[item.form_field_name].custody"
                    type="input"
                  >
                    <template slot="prepend">被扣押</template>
                    <template slot="append">人</template>
                  </el-input>
                </div>
                <div class="zv-form-item-col">
                  <el-input
                    v-model="formData[item.form_field_name].affect"
                    type="input"
                  >
                    <template slot="prepend">受影响</template>
                    <template slot="append">人</template>
                  </el-input>
                </div>
              </div>
            </el-form-item>
            
            <el-form-item :label="item.field_name+':'" v-if="item.field_type == '地址多个输入' && item.enable">
              <div class="adressList" v-for="(items,indexs) in formData[item.form_field_name]" :key="indexs">
                <el-select
                  class="el-input-width1"
                  v-model="items.area_id"
                  filterable
                >
                  <el-option
                    v-for="itemLi in areaList"
                    :key="itemLi.id"
                    :label="itemLi.full_area_name"
                    :value="itemLi.id"
                  >
                  </el-option>
                </el-select>
                <el-input
                    class="el-input-width20"
                    v-model="items.county"
                    type="input"
                    placeholder="县"
                  >
                </el-input>
                <el-input
                    class="el-input-width20"
                    v-model="items.village"
                    type="input"
                    placeholder="乡镇"
                  >
                </el-input>
                <el-input
                    class="el-input-width20"
                    v-model="items.community"
                    type="input"
                    placeholder="社区"
                  >
                </el-input>
                <el-input
                    class="el-input-width20"
                    v-model="items.longitude"
                    type="input"
                    placeholder="经度"
                  >
                </el-input>
                <el-input
                    class="el-input-width20"
                    v-model="items.latitude"
                    type="input"
                    placeholder="纬度"
                  >
                </el-input>
                <el-button style="margin-left: 10px" type="primary" @click="addressBtnClick(indexs)">{{
                  indexs == 0 ? "添加" : "删除"
                }}</el-button>
              </div>
            </el-form-item>

            <el-form-item :label="item.field_name+':'" v-if="item.field_type == '视频上传' && item.enable">
              <video v-if="formData[item.form_field_name]" :src="formData[item.form_field_name]" style="width: 300px;height: 200px" controls="controls"></video>
              <el-upload
                v-else
                :action="imageUrl"
                accept="video/*"
                :show-file-list="true"
                :data="videoData"
                name="file"
                list-type="picture-card"
                :limit="1"
                :on-success="(value)=> handleVideoSuccess(item.form_field_name, value)"
                :before-upload="beforeUploadVideo"
                :on-remove="(value)=> handleRemove(item.form_field_name, value)">
                <i class="el-icon-plus"></i>
              </el-upload>
              <el-button style="margin-left: 20px" v-if="formData[item.form_field_name]" @click="formData[item.form_field_name] = ''" type="primary">删除视频</el-button>
            </el-form-item>

          </div>

          <!-- <el-form-item label="所属地区:" prop="area_id">
            <el-select
                class="el-input-width1"
                v-model="formData.area_id"
                filterable
              >
                <el-option
                  v-for="item in areaList"
                  :key="item.id"
                  :label="item.full_area_name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
          </el-form-item> -->

        
          <!-- <el-form-item label="事发时间:" prop="event_occurred_time">
            <el-date-picker
              class="el-input-width1"
              v-model="formData.event_occurred_time"
              type="datetime"
              placeholder="选择事发时间"
              value-format="timestamp"
            >
            </el-date-picker>
          </el-form-item> -->

          

          <!-- @ready="onEditorReady($event)" -->
          <!-- <el-form-item label="正文" prop="content">
            <quill-editor v-model="formData.content"
              ref="myQuillEditor"
              class="editer"
              :options="editorOption">
            </quill-editor>
          </el-form-item> -->

          <!-- <el-form-item label="对中资企业及华人影响:" prop="affect_to_chinese">
            <el-input
              class="el-textarea-width1"
              v-model="formData.affect_to_chinese"
              type="textarea"
              :rows="3"
              placeholder="请输入影响"
            ></el-input>
          </el-form-item> -->


          <el-form-item label="请输入标签:" prop="tags">
            <el-input
              class="el-input-width500"
              v-model="formData.tags"
            ></el-input>
            <span style="margin-left: 10px;color: gray; font-size: 12px">*多个用逗号隔开（英文逗号）</span>
          </el-form-item>

          <el-form-item label="状态:" prop="ispublish">
            <el-radio-group v-model="formData.ispublish">
              <el-radio :label="0">待审核</el-radio>
              <el-radio :label="1">审核通过</el-radio>
              <el-radio :label="2">审核失败</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item label-width="auto" style="margin-left: 100px;margin-top: 20px">
            <el-button type="primary" :loading="btn_loading" @click="isEdit ? doSubmit(ids):doSubmit()">提交</el-button>
            <el-button @click="doCancel">返回</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import api from "./api";
import formPageMixin from "@/mixins/formPageMixin";
import TipUtil from "@/utils/utils/TipUtil";
import { quillEditor } from 'vue-quill-editor' //调用编辑器
import uploadFlie from "@/components/unloadFile/index";
import tokenService from "@/utils/services/token_service"

export default {
  name: "CreateEvent",
  mixins: [formPageMixin],
  components: { uploadFlie,quillEditor },
  data() {
    let vm = this;
    return {
      ids: vm.$route.query.id,
      editorOption: {
        placeholder: '请输入',
      },
      categoryList: '',
      areaList: '',
      isEdit: false,   // 是否为编辑
      riskList: [
        { label: '潜在风险'},
        { label: '轻微风险'},
        { label: '严重风险'},
        { label: '恶劣风险'},
        { label: '极度恶劣风险'}
      ],
      formData: {
        type: 1,
        ispublish: 1
      },
      videoData: {
        //写死参数 后续修改
        sid: tokenService.getToken(),
        type: "4",
        dir: "article_media_video"
      },
      imageData: {
        //写死参数 后续修改
        sid: tokenService.getToken(),
        type: "1",
        dir: "article_special_cover"
      },
      imageUrl: "http://yjapi.ciwei.com/api.php?do=admin_file_upload", //写死参数
      fileList: [], //文件列表
      formRules: {
        title: [
          {
            required: true,
            message: "专题名不能为空",
            trigger: "blur"
          }
        ],
        content: [
          {
            required: true,
            message: "正文不能为空",
            trigger: "blur"
          }
        ],
        type: {
          required: true,
          message: "类型不能为空",
          trigger: "change"
        },
        article_category_id: {
          required: true,
          message: "所属分类",
          trigger: "change"
        }
      },
      categoryTypeList: '',
      itemData: '',
      // 影响等级库
      effectData: [
        {label: "潜在风险"},
        {label: "轻微风险"},
        {label: "严重风险"},
        {label: "恶劣风险"},
        {label: "极度恶劣风险"}
      ],
      // 风险等级库
      riskData: [
        {label: "极高"},
        {label: "高"},
        {label: "较高"},
        {label: "中等"},
        {label: "低"}
      ],
      areaData: '', //地区库
      checkList: [],
      // 上传封面处理
      dialogImageUrl: '',
      videoUrl: '',
      dialogVisible: false,
      involvedData1: [], 
      jsonDatas: {},
      btn_loading: false
    }
  },

  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill
    }
  },

  methods: {
    beforeUploadVideo(file) {
      if (['video/mp4', 'video/ogg', 'video/flv','video/avi','video/wmv','video/rmvb'].indexOf(file.type) == -1) {
        this.$message.error('请上传正确的视频格式');
        return false;
      }
    },
    async sourceListFn() {
      let res = await api.sourceList()
      console.log(res)
    },
    // 上传图片处理
    handleRemove(name,file) {
      this.formData[name].map((item,index)=> {
        if(item.url == file.url) {
          this.formData[name].splice(index, 1)
        }
      })
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleSuccess(name,file) {
      console.log(this.formData[name])
      console.log(this.formData)
      this.formData[name].push({url: file.file})
    },
    handleVideoSuccess(name,file) {
      // this.videoUrl = file.file
      this.$set(this.formData,name,file.file)
      // this.formData[name] = file.file
    },
    async changeCategory(val) {
      let datas = {
        id: val.length == undefined ? val:val[val.length-1]
      }
      let res = await api.categoryInfoList(datas)
      let configs = res.info.field_config
      // 处理下拉菜单不同库
      configs.map(async(item)=> {
        // 处理多选初始值
        if(item.field_type == '枚举多选') {
          if(!this.isEdit && item.enable) {
            this.$set(this.formData,item.form_field_name,[])
          }else {
            if(this.formData[item.form_field_name] == "[]") {
              this.$set(this.formData,item.form_field_name,[])
            }
          }
        }
        // 处理图片上传初始值
        if(item.field_type == '图片上传') {
          if(!this.isEdit && item.enable) {
            this.$set(this.formData,item.form_field_name,[])
          }else {
            // 处理编辑时，没有图片
            if(this.formData[item.form_field_name] == "[]") {
              this.$set(this.formData,item.form_field_name,[])
            }
          }
        }
        if(item.field_config_data != null) {
          if(item.field_config_data.options_lib) {
            if(item.field_config_data.options_lib == "事件类型库") {
              item.eventList = this.categoryTypeList
            }
          }
        }
        // 处理联动多选
        if(item.field_type == '联动多选') {
          // 处理编辑加载失败
          if(this.categoryTypeList == "") {
            // 判断联动多选库
            if(item.field_config_data != null) {
              if(item.field_config_data.options_lib) {
                if(item.field_config_data.options_lib == "事件类型库") {
                  let List = await api.eventCategoryList({parent_id: 0})
                  this.$set(item,"LinkList",List.list)
                }else if(item.field_config_data.options_lib == "统计类型库") {
                  let List = await api.listDroplist({parent_id: 0})
                  this.$set(item,"LinkList",List.list)
                }
              }
            }
          }else {
            item.LinkList = this.categoryTypeList
          }
          if(!this.isEdit && item.enable) {
            // this.$set(this.formData,item.form_field_name,[])
          }
        }
        // 人数统计触发事件
        if(item.field_type == '人数统计') {
          if((!this.isEdit && item.enable) || this.formData[item.form_field_name] == undefined) {
            this.$set(this.formData,item.form_field_name,{
              death: '',
              injured: '',
              death_and_injured: '',
              missing: '',
              kidnap: '',
              arrest: '',
              captured: '',
              strike: '',
              march: '',
              rape: '',
              disaster: '',
              infection: '',
              involved: '',
              custody: '',
              affect:''
            })
          }
        }

        // 地址多个输入
        if(item.field_type == '地址多个输入') {
          if((!this.isEdit && item.enable) || this.formData[item.form_field_name] == undefined) {
            this.$set(this.formData,item.form_field_name,[
              {
                area_id: '',
                county: '',
                village: '',
                community: '',
                longitude: '',
                latitude: ''
              }
            ])
          }
        }
      })
      this.itemData = configs
    },

    // 地区库下拉菜单
    // async areaListFn() {
    //   let res = await api.areaList({
    //     pagesize: 9999
    //   })
    //   this.areaData = res.list
    //   this.areaList = res.list
    // },

    async categoryTypeListFn() {
      let res = await api.listDroplist({parent_id: 0})
      this.categoryTypeList = res.list
    },
    // categoryList列表
    async categoryListFn() {
      let res = await api.categoryList({
        parent_id: 0
      })
      this.categoryList = res.list
    },
    // 所属地区下拉菜单
    async getAreaList() {
      this.areaList = await this.$commFunc.getAreaList({
        // area_type: 2
      });
      this.areaData = this.areaList
    },

    async specialEditData() {
      let res = await api.articleInfo({
        id: this.$route.query.id
      })
      this.formData = res.info
      this.formData.tags = this.formData.tags_name
      
      // this.$set(this.formData,"article_category_id",[this.formData.article_category_id])
      this.changeCategory(this.formData.article_category_id)
      // this.categoryListFn()
      
    },
    
    // 条件型 - 事件选择
    async conditionSelect(val) {
      let selectAreaArr = this.formData.addressData
      if(selectAreaArr[0].address1) {
        let cityId = selectAreaArr[0].address1
        let countryId = this.getCountryIdByCity(cityId)
        let res = await api.getEventFieldOptionList({
          area_id: countryId,
          risk_id: val
        })
        
        this.eventRiskFieldOptions2 = res.list
        this.eventRiskFieldLists = res.field_list
      }
    },

    addressBtnClick(index) {
      console.log(index)
      if (index == 0) {
        this.addAdressItem()
      } else {
        this.deleteAddressItem(index);
      }
    },

    addAdressItem() {
      this.itemData.map(item=> {
        // 地址多个输入
        if(item.field_type == '地址多个输入') {
          this.formData[item.form_field_name].push({
            area_id: '',
            county: '',
            village: '',
            community: '',
            longitude: '',
            latitude: ''
          })
        }
      })
    },

    deleteAddressItem(index) {
      this.itemData.map(item=> {
        // 地址多个输入
        if(item.field_type == '地址多个输入') {
          if (this.formData[item.form_field_name].length > 1) {
            this.formData[item.form_field_name].splice(index, 1);
          } else {
            TipUtil.message("至少保留一个数据", "warning");
          }
        }
      })
    },
   
    doCancel() {
      this.$router.back()
    },

    doSubmit(ids) {
      this.btn_loading = true
      this.$refs.myForm.validate(async valid => {
        if (valid) {
          let msg
          let jsons
          let params
          this.itemData.map(item=> {
            if(this.formData[item.form_field_name] != undefined) {
              jsons = JSON.stringify(this.formData[item.form_field_name],1000)
              this.$set(this.jsonDatas,item.form_field_name,jsons)
            }
          })
          params = {
            ...this.formData,
            ...this.jsonDatas
          }
          // 处理所属分类为数组的情况
          if(params.article_category_id.length > 0) {
            params.article_category_id = params.article_category_id[params.article_category_id.length-1]
          }

          if(ids) {
            this.formData.id = ids
            let res = await api.articleEdit(params)
            this.btn_loading = false
            msg = "修改成功！"
          }else {
            let res = await api.articleAdd(params)
            this.btn_loading = false
            msg = "新增成功！"
          }
          
          this.$message({
            message: msg,
            type: "success"
          });
          setTimeout(()=> {
            this.$router.push({
              name: "articleList"
            });
          },1000)
        }
      })
    } 
  },
  created() {
    if(this.$route.query.id) {
      this.isEdit = true
      this.specialEditData()
    }
    this.categoryListFn()
    // this.categoryTypeListFn()
    // this.areaListFn()
    this.getAreaList()
    // this.sourceListFn()
  },
  mounted() {},
  beforeDestroy() {}
};
</script>

<style lang="less" scoped>
.el-input-width500 {
  width: 500px !important;
}
.el-input-width20 {
  width: 120px;
  margin-left: 10px;
}
.condition {
  .el-select {
    margin-right: 10px;
  }
}
.event-risk-wrap {
  padding: 10px 10px 18px;
}
.event-risk-inner {
  padding-bottom: 10px;
  border-bottom: 2px solid #ccc;
  font-size: 16px;
  line-height: 16px;
  display: inline-block;
}
.zv-form-item-col {
  margin-top: 10px;
}
.adressList {
  margin-top: 10px;
  &:nth-child(1) {
    margin-top: 0px;
  }
}
</style>
<style>
  .edit_container {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
  .ql-editor{
      height:200px;
    }
</style>
